<script lang="ts" module>
	import type { ClassValue, SVGAttributes } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';
	import { CROSS_SIZE_VARIANTS } from '../variants';
	import type { IconSrc } from './icons';

	export const iconVariants = tv({
		base: 'shrink-0',
		variants: { size: CROSS_SIZE_VARIANTS },
		defaultVariants: { size: '400' }
	});

	export interface IconProps
		extends Omit<SVGAttributes<SVGSVGElement>, 'class'>, VariantProps<typeof iconVariants> {
		class?: ClassValue;
		filled?: boolean;
		ref?: SVGSVGElement | null;
		src: IconSrc;
	}
</script>

<script lang="ts">
	let {
		class: className,
		filled = false,
		ref = $bindable(null),
		size,
		src,
		...rest
	}: IconProps = $props();
</script>

<svg
	bind:this={ref}
	class={[iconVariants({ size }), className]}
	focusable="false"
	aria-hidden={rest['aria-label'] || rest['aria-labelledby'] ? undefined : true}
	data-filled={filled || undefined}
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	{...rest}
>
	<src.icon
		width={src.badge ? 18 : 24}
		height={src.badge ? 18 : 24}
		stroke-width={filled ? 2.5 : 1.75}
	/>
	{#if src.badge}
		<src.badge x={13} y={13} width={11} height={11} stroke-width={filled ? 2.5 : 1.75} />
	{/if}
</svg>
